import {ApiClient} from '@hconnect/apiclient'
import {useDelayedLoadingMutation} from '@hconnect/common/hooks'
import {StoppageDto as Stoppage} from '@hconnect/common/types'
import {UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {QueryKey, type RuntimeAdjustPayload} from '../../types'

export const useAdjustRuntime = (
  plantId: string,
  options?: UseMutationOptions<Stoppage, AxiosError, RuntimeAdjustPayload>
) => {
  const queryClient = useQueryClient()

  return useDelayedLoadingMutation({
    mutationFn: async ({runningTimeId, start, end}: RuntimeAdjustPayload) => {
      const path = `/kpi/runningtimes/${plantId}/${runningTimeId}`

      const response = await ApiClient.axiosInstance.put<Stoppage>(path, {start, end})
      return response.data
    },
    ...options,
    onSuccess: async (data, variables, context, mutation) => {
      await queryClient.invalidateQueries({queryKey: [QueryKey.PlantRunningTimes]})
      await options?.onSuccess?.(data, variables, context, mutation)
    },
    onError: (error, ...args) => {
      options?.onError?.(error, ...args)
    }
  })
}
